import React from 'react';
import {connect} from "react-redux";
import Select from 'react-select';

import SearchField from '../../components/SearchField';
import ModuleItem from './ModuleItem';
import {
    activateModuleItem,
    deactivateModuleItem,
    getModuleItems,
    getSelectedModule,
    updateArticleGtin,
    updateArticleErpIdno,
    updateVendorArticleNumber,
    updateArticleName,
    updateModuleItemQuery,
    updateActiveItemFilter,
    updateItemStockStatusFilter
} from "./reducer";

const ModuleDetails = (props) => {

    const handleModuleItemQueryChange = (query) => {
        props.updateModuleItemQuery(query);
    };

    const applyActiveFilter = (filterOption) => {
        props.updateActiveItemFilter(filterOption.value);
    };

    const applyStatusFilter = (filterOption) => {
        props.updateItemStockStatusFilter(filterOption.value);
    };

    const activeFilterOptions = [
        {value: '', label: 'Alle'},
        {value: true, label: 'aktiv'},
        {value: false, label: 'inaktiv'}
    ];

    const selectedActiveOption = activeFilterOptions.find(option => option.value === props.filters.active);

    const statusFilterOptions = [
        {value: '', label: 'Alle'},
        {value: 'IN_STOCK', label: 'mit Bestand'},
        {value: 'NO_STOCK', label: 'ohne Bestand'}
    ];

    const selectedStatusOption = statusFilterOptions.find(option => option.value === props.filters.stockStatus);

    return (
        <div className="card">
            <div className="card-header">Moduldetails {props.module.name}</div>
            <div className="card-body">
                <div className="row">
                    <div className="col-2">
                        <Select
                            name="status"
                            value={selectedActiveOption}
                            onChange={applyActiveFilter}
                            options={activeFilterOptions}
                        />
                    </div>
                    <div className="col-2">
                        <Select
                            name="status"
                            value={selectedStatusOption}
                            onChange={applyStatusFilter}
                            options={statusFilterOptions}
                        />
                    </div>
                    <div className="col-3">
                        <SearchField className="mb-2 mr-sm-2 mb-sm-0" value={props.query}
                                     onCommit={handleModuleItemQueryChange}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <table className="table table-striped">
                            <thead>
                            <tr>
                                <th>Modul</th>
                                <th>Brand</th>
                                <th>SAP-Nr.</th>
                                <th>Artikel-GTIN</th>
                                <th>Artikel-Bezeichnung</th>
                                <th>Hersteller-Artikelnr.</th>
                                <th>Bestand</th>
                                <th>Aktiv ja/nein</th>
                            </tr>
                            </thead>
                            <tbody>
                            {props.moduleItems.map((moduleItem) => {
                                return (
                                    <ModuleItem {...moduleItem}
                                                key={moduleItem.id}
                                                activateModuleItem={props.activateModuleItem}
                                                deactivateModuleItem={props.deactivateModuleItem}
                                                updateArticleErpIdno={props.updateArticleErpIdno}
                                                updateArticleGtin={props.updateArticleGtin}
                                                updateArticleName={props.updateArticleName}
                                                updateVendorArticleNumber={props.updateVendorArticleNumber}/>)
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {

    let selectedModule = getSelectedModule(state.module);
    selectedModule = selectedModule ? selectedModule.toJS() : null;

    return {
        module: selectedModule,
        moduleItems: getModuleItems(state.module).toJS(),
        moduleItemQuery: state.module.get('moduleItemQuery'),
        filters: state.module.get('filters').toJS()
    };
}

const ConnectedModuleDetails = connect(mapStateToProps, {
    updateModuleItemQuery,
    updateArticleGtin,
    updateArticleErpIdno,
    updateVendorArticleNumber,
    updateActiveItemFilter,
    updateItemStockStatusFilter,
    updateArticleName,
    deactivateModuleItem,
    activateModuleItem
})(ModuleDetails);

export default ConnectedModuleDetails;



// WEBPACK FOOTER //
// ./src/admin/module/overview/ModuleDetails.js